<template>
  <div>
    <el-dialog
      title="编辑"
      :visible="dialogShow"
      width="30%"
      @open="init"
      @close="handleDialog"
      :close-on-click-modal="false"
    >
      <div>
        <div style="font-size: 16px; display: flex">
          <i
            class="el-icon-info"
            style="color: #e6a23c; font-size: 22px; margin-right: 6px"
          ></i
          >代收阶梯费率
        </div>
        <p>
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="基础费率" prop="basePaymentRate">
              <el-input
                v-model="form.basePaymentRate"
                :disabled="1 === 1"
                type="text"
                size="small"
                style="width: 300px"
              ></el-input>
            </el-form-item>

            <el-form-item label="是否开启" prop="openTieredBilling">
              <el-col :span="12">
                <el-select
                  v-model="form.openTieredBilling"
                  placeholder="--请选择--"
                  size="small"
                >
                  <el-option label="关闭" value="00"></el-option>
                  <el-option label="开启" value="01"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="阶梯模式" prop="tieredBillingMode">
              <el-col :span="12">
                <el-select
                  v-model="form.tieredBillingMode"
                  placeholder="--请选择--"
                  :disabled="form.openTieredBilling === '00'"
                  size="small"
                >
                  <el-option label="当日订单" value="00"></el-option>
                  <el-option label="次日订单" value="01"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="一级阶梯" prop="paymentRateStaging1">
              <el-input
                v-model="form.paymentRateStaging1"
                :disabled="form.openTieredBilling === '00'"
                type="text"
                size="small"
                style="width: 140px"
              ></el-input>
              &nbsp;&nbsp;费率：
              <el-input
                v-model="form.paymentRateStagingRate1"
                :disabled="form.openTieredBilling === '00'"
                type="text"
                size="small"
                style="width: 140px"
              ></el-input>
            </el-form-item>

            <el-form-item label="二级阶梯" prop="paymentRateStaging2">
              <el-input
                v-model="form.paymentRateStaging2"
                :disabled="form.openTieredBilling === '00'"
                type="text"
                size="small"
                style="width: 140px"
              ></el-input>
              &nbsp;&nbsp;费率：
              <el-input
                v-model="form.paymentRateStagingRate2"
                :disabled="form.openTieredBilling === '00'"
                type="text"
                size="small"
                style="width: 140px"
              ></el-input>
            </el-form-item>

            <el-form-item label="三级阶梯" prop="paymentRateStaging3">
              <el-input
                v-model="form.paymentRateStaging3"
                :disabled="form.openTieredBilling === '00'"
                type="text"
                size="small"
                style="width: 140px"
              ></el-input>
              &nbsp;&nbsp;费率：
              <el-input
                v-model="form.paymentRateStagingRate3"
                :disabled="form.openTieredBilling === '00'"
                type="text"
                size="small"
                style="width: 140px"
              ></el-input>
            </el-form-item>
          </el-form>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
export default {
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        appId: '',
        openTieredBilling: '',
        tieredBillingMode: '',
        basePaymentRate: '',
        paymentRateStaging1: '',
        paymentRateStaging2: '',
        paymentRateStaging3: '',
        paymentRateStagingRate1: '',
        paymentRateStagingRate2: '',
        paymentRateStagingRate3: '',
      },
      rules: {},
    }
  },
  methods: {
    init() {
      this.form = this.formData
    },
    handleDialog() {
      this.form = {
        appId: '',
        openTieredBilling: '',
        tieredBillingMode: '',
        basePaymentRate: '',
        paymentRateStaging1: '',
        paymentRateStaging2: '',
        paymentRateStaging3: '',
        paymentRateStagingRate1: '',
        paymentRateStagingRate2: '',
        paymentRateStagingRate3: '',
      }
      this.$refs['form'].resetFields()
      this.$emit('update:show', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            ...this.form,
          }
          this.$axios
            .post('/merchant/tieredBillingUpdate', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:show', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        }
      })
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal
    },
  },
}
</script>
  <style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>